import classNames from 'classnames';

const CarbConscious = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 80"
    className={classNames('dietary-tag', className)}
  >
    <title>Carb Conscious</title>
    <g id="bread">
      <path
        className="dietary-tag__bread"
        d="M13.84,41.76,12.28,41A17.71,17.71,0,0,1,2.33,25.2,18.08,18.08,0,0,1,20.64,7.39C27.46,7.39,35.87,12,40,20.63,43.18,14.18,52.55,7.4,59.36,7.4A18.1,18.1,0,0,1,77.67,25.22a17.73,17.73,0,0,1-10,15.87l-1.56.67V73.3H13.85Z"
      />
    </g>
  </svg>
);

CarbConscious.propTypes = {
  className: PropTypes.string,
};

CarbConscious.defaultProps = {
  className: '',
};

export default CarbConscious;
